import { render, staticRenderFns } from "./todo_bricks.vue?vue&type=template&id=7fbd73e2&scoped=true&"
import script from "./todo_bricks.vue?vue&type=script&lang=js&"
export * from "./todo_bricks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbd73e2",
  null
  
)

export default component.exports